// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../imageSize.fragment.generated';
export const QuestionnaireSignUpStepFragmentDoc = `
    fragment questionnaireSignUpStep on QuestionnaireSignUpStep {
  title
  description
  backgroundColor
  image {
    ...cmsImageSizes
  }
  submitButtonLabel
}
    `;